const toggleWishlistBtnClass = () => {
    const whishlistBtn = document.querySelectorAll('.offers-overview__name-btn');
    whishlistBtn.forEach(btn => btn.addEventListener('click', () => {
        btn.classList.toggle('animate');
        btn.classList.toggle('active');
    }))
}

const setStars = () => {
    const starsSets = document.querySelectorAll('.stars');
    starsSets.forEach((starsSet, index) => {
        const stars = Array.from(starsSet.children).filter(child => child.classList.contains('stars__star'));
        const rate = (+starsSet.dataset.stars > 5 || +starsSet.dataset.stars <= 0) ? 5 : +starsSet.dataset.stars;
        const rateRest = rate - Math.floor(rate);
        const ratePrecent = `${Math.ceil(rateRest * 100)}%`;
        const gradientId = `grad${index}`;
        const gradient = `
            <linearGradient id="${gradientId}" x1="0" x2="1" y1="0" y2="0">
                <stop offset="${ratePrecent}" stop-color="#dc1e1e"/>
                <stop offset="${ratePrecent}" stop-color="white"/>
            </linearGradient>`;

        stars.forEach((star, index) => {
            if ((index + 1) === Math.ceil(rate) && (Math.ceil(rate) - rate)) {
                star.firstElementChild.innerHTML += gradient;
                star.children[1].firstElementChild.setAttribute('fill', `url(#${gradientId})`);
            }
            if ((index + 1) <= Math.floor(rate)) star.classList.add('stars__star--full');
        })

    })
}

const findLastProductInRow = (noOfColumns) =>{
    document.querySelectorAll('.without-border').forEach(product => product.classList.remove('without-border'));
    Array.from(document.querySelectorAll('.offers-overview'))
        .filter((_, index) => (index+1) % noOfColumns === 0)
        .forEach(product => product.classList.add('without-border'));
}

const runOnResize = () =>{
    let noOfColumns = Math.floor(document.querySelector('.products').clientWidth/282)
    findLastProductInRow(noOfColumns);
    window.addEventListener('resize', () => {
        let newNoOfColumns = Math.floor(document.querySelector('.products').clientWidth/282);
        if(noOfColumns !== newNoOfColumns){
            noOfColumns = newNoOfColumns;
            findLastProductInRow(noOfColumns);
        }
    })
}

const runOffersFunctions = () => {
    const offers = document.querySelector('.offers-overview');
    const shop = document.querySelector('.products');
    if (offers) {
        toggleWishlistBtnClass();
        setStars();
    }
    if(shop){
        runOnResize();
    }
}

runOffersFunctions();